import { combineReducers } from "redux";

import upcomingEvents from "../events/reducers/events";
import latestStories from "./latestStories";
import navigation from "./navigation";
import newsletters from "../subscriptions/reducers/newsletters";
import storiesStream from "./storiesStream";
import subscriptions from "../subscriptions/reducers/subscriptions";

export default combineReducers({
  upcomingEvents,
  latestStories,
  navigation,
  newsletters,
  storiesStream,
  subscriptions,
});
